import { useMutation } from "react-query"

import axios from "axios"

import {
  FailureMessage,
  SendReceiptPostMutateProps,
  ServiceFailedToReturn,
  SendReceiptPostProps,
  CustomerContactInfoType,
} from "./types"
import {
  customerBaseApi,
  sendReceiptToCustomerPath,
  prepareContactInfoBody,
} from "./utils"

export const useSendReceiptPost = (args?: SendReceiptPostProps) => {
  const { onSuccess } = args ?? { onSuccess: () => {} }

  const postData = async ({
    contactInfo,
    customerUuid,
    purchaseUuid,
  }: SendReceiptPostMutateProps) => {
    try {
      // only for development reasons
      // return {
      //   ...contactInfo,
      // }

      await axios.post(
        customerBaseApi(sendReceiptToCustomerPath(customerUuid, purchaseUuid)),
        prepareContactInfoBody(contactInfo),
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: (status: number) => status === 202,
        },
      )

      return {
        ...contactInfo,
      }
    } catch (err: any) {
      const { status } = err.response || {}
      let failureMessage

      switch (status) {
        case 404:
          failureMessage = FailureMessage.CUSTOMER_OR_PURCHASE_NOT_FOUND
          break
        case 412:
          failureMessage = FailureMessage.PHONE_OR_EMAIL_REQUIRED
          break
        default:
          failureMessage = FailureMessage.OPERATION_ERROR
          break
      }
      return {
        failureMessage,
      }
    }
  }

  const mutateState = useMutation<
    ServiceFailedToReturn & CustomerContactInfoType,
    Error,
    SendReceiptPostMutateProps
  >(postData, { onSuccess })

  return mutateState
}
